import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { BranchLocationModel } from '../../../shared/models/branch-location.model';

@Injectable({
    providedIn: 'root',
})
export class BranchLocationService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/branch_locations`;

    // Create an application
    createLoanBranchLocation(application: BranchLocationModel): Observable<BranchLocationModel> {
        return this.post(this.apiUrl, application);
    }

    // Read all applications
    getLoanBranchLocations(): Observable<BranchLocationModel[]> {
        return this.get(this.apiUrl);
    }

    // Read a single application by ID
    getLoanBranchLocationById(id: string): Observable<BranchLocationModel> {
        return this.get(`${this.apiUrl}/${id}`);
    }

    // Update an application
    updateLoanBranchLocation(id: string, application: BranchLocationModel): Observable<BranchLocationModel> {
        return this.put(`${this.apiUrl}/${id}`, application);
    }

    // Delete an application
    deleteLoanBranchLocation(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }
}
